export const customTheme = theme => {
  return ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: 'rgba(158, 158, 158, 0.25)'
    },
    height: '26px'

  });
};

export const customStyles = {
  control: styles => {
    return {
      ...styles,
      borderRadius: '3px',
      fontSize: '14px',
      minWidth: '140px',
      width: '100%',
      minHeight: '26px',
      lineHeight: '18px',
      padding: '0',
      transition: '0.2s all ease-in-out',
      height: '40px',
      boxShadow: 'none',
      cursor: 'pointer',

      ':hover': {
        boxShadow: 'none'
      }
    };
  },

  clearIndicator: styles => {
    return {
      ...styles,
      padding: 0,
      ':hover': {
        color: 'red'
      }
    };
  },

  indicatorSeparator: styles => {
    return {
      ...styles,
      display: 'none'
    };
  },

  option: (styles, { isFocused }) => {
    return {
      ...styles,
      cursor: 'pointer',
      backgroundColor: isFocused ? 'rgba(158, 158, 158, 0.10)' : '#fff',
      fontSize: '14px',
      color: '#3f3f3f'
    };
  }
};
